import React from 'react';
import { Table } from 'semantic-ui-react';
import OnOffNoLabel from '../OnOffNoLabel';

const MultiSelectCell = ({
  label,
  checked,
  onClick,
  disabled,
}) => (
  <Table.Cell collapsing disabled={disabled} className="aridhia-multi-select-cell">
    <OnOffNoLabel
      checked={checked}
      className="aridhia-multi-select-cell-toggle"
      disabled={disabled}
      label={label}
      message="hidden.label.select"
      onClick={onClick}
    />
  </Table.Cell>
);

export default MultiSelectCell;
